import { render, staticRenderFns } from "./ConsentsPage.vue?vue&type=template&id=760b5496&scoped=true&"
import script from "./ConsentsPage.vue?vue&type=script&lang=js&"
export * from "./ConsentsPage.vue?vue&type=script&lang=js&"
import style0 from "./ConsentsPage.vue?vue&type=style&index=0&id=760b5496&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760b5496",
  null
  
)

export default component.exports